import { render, staticRenderFns } from "./sksh.vue?vue&type=template&id=1e5ba2b2&scoped=true&"
import script from "./sksh.vue?vue&type=script&lang=js&"
export * from "./sksh.vue?vue&type=script&lang=js&"
import style0 from "./sksh.vue?vue&type=style&index=0&id=1e5ba2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ba2b2",
  null
  
)

export default component.exports